import useLang from '@/composables/lang'
import { createI18n } from 'vue-i18n'

const { messages } = useLang()

const i18n = createI18n({
  globalInjection: true,
  legacy: false,
  locale: 'fr',
  fallbackLocale: 'fr',
  messages
})

export default i18n
